import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatCalendarHeader} from '@angular/material/datepicker';
import {DateAdapter} from '@angular/material/core';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-today-calendar-header',
  templateUrl: './today-calendar-header.component.html',
  styleUrls: ['./today-calendar-header.component.scss'],
  standalone: true,
  imports: [MatButtonModule, MatTooltipModule],
})
export class TodayCalendarHeaderComponent extends MatCalendarHeader<DateTime> {
  private dateAdapter = inject<DateAdapter<DateTime>>(DateAdapter);

  get todayDisabled(): boolean {
    const today = this.dateAdapter.today();
    const {minDate, maxDate, dateFilter} = this.calendar;
    if (minDate && this.dateAdapter.compareDate(today, minDate) < 0) return true;
    if (maxDate && this.dateAdapter.compareDate(today, maxDate) > 0) return true;
    return dateFilter ? !dateFilter(today) : false;
  }

  goToToday(event: MouseEvent): void {
    const today = this.dateAdapter.today();
    this.calendar.activeDate = today;
    this.calendar._userSelection.emit({value: today, event});
  }
}
